import { WhatMakesUsDifferentSingleComponentProps } from "./WhatMakesUsDifferent";

import { PiHandHeartThin } from "react-icons/pi";
import { LiaCreditCardSolid } from "react-icons/lia";
import { BiHappy } from "react-icons/bi";
import { MdOutlineLocalShipping } from "react-icons/md";
import { FaLock, FaHeart } from "react-icons/fa";

const forSupporters: WhatMakesUsDifferentSingleComponentProps[] = [
  {
    icon: <PiHandHeartThin />,
    header: "Shop for a Cause",
    subText: "Buy personalized products and support a team you cate about!",
  },
  {
    icon: <LiaCreditCardSolid />,
    header: "Simple Donation Process",
    subText: "Give in seconds - no account or registration required!",
  },
  {
    icon: <BiHappy />,
    header: "Know Who You're Supporting",
    subText: "Each page shows who you're helping and why it matters.",
  },
  {
    icon: <MdOutlineLocalShipping />,
    header: "Free Shipping Over $120",
    subText:
      "Enjoy fast delivery with no extra fees on orders over $120 in the continental US (excluding donations).",
  },
  {
    icon: <FaLock />,
    header: "Secure Payments",
    subText: "Your information is protected with industry-standard security.",
  },
  {
    icon: <FaHeart />,
    header: "Love your Purchase",
    subText: "We offer quality items that we know you will love.",
  },
];

export default forSupporters;
